import { BitsRpcClient } from '@bits/rpc';
import { Session } from 'next-auth';
import { getSession } from 'next-auth/react';

let session: Promise<Session & { user: { accessToken: string } }> | null = null;

export const rpcClient = new BitsRpcClient(async () => {
  if (!session) {
    session = getSession() as Promise<
      Session & {
        user: { accessToken: string };
      }
    >;
  }
  return (await session).user.accessToken;
});
